import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import PanelLayout from "../components/PanelLayout";
import ToggleTTLSeconds from "../components/ToggleTTLSeconds";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import CacheContextPropertyInput from "../components/CacheContextPropertyInput";
import CacheConstantValuesInput from "../components/CacheConstantValuesInput";
import MultiplePropertyContent from "../components/MultiplePropertyContent";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import CheckBox from "../components/CheckBox";

class CachePanel extends Component {
    constructor(props) {
        super(props);

        this.hasOptions = this.props.clickedNodeInfo.extras.options;
        this.hasContextProperties = this.hasOptions && this.hasOptions.contextProperties;
        this.hasAppendToCacheKey = this.hasOptions && this.hasOptions.appendToCacheKey;
        this.hasToggleTTLSecondsSelected = this.hasOptions && this.hasOptions.toggleTTLSecondsSelected;
        this.hasToggleRandomTTLSecondsSelected = this.hasOptions && this.hasOptions.toggleRandomTTLSecondsSelected;
        this.hasToggleTTLSeconds = this.hasOptions && this.hasOptions.ttlSeconds;
        this.hasToggleRandomTTLSeconds = this.hasOptions && this.hasOptions.extraRandomTtlSeconds;

        this.state = {
            includeWidgetName: true,
            includeNodeName: true,
            contextProperties: this.hasContextProperties ? this.hasOptions.contextProperties : [],
            appendToCacheKey: this.hasAppendToCacheKey ? this.hasOptions.appendToCacheKey : [],
            toggleTTLSecondsSelected: this.hasToggleTTLSecondsSelected ? this.hasOptions.toggleTTLSecondsSelected : false,
            toggleRandomTTLSecondsSelected: this.hasToggleRandomTTLSecondsSelected ? this.hasOptions.toggleRandomTTLSecondsSelected : false,
            ttlSeconds: this.hasToggleTTLSeconds ? this.hasOptions.ttlSeconds : '3600',
            extraRandomTtlSeconds: this.hasToggleRandomTTLSeconds ? this.hasOptions.extraRandomTtlSeconds : '30',
            shouldFocus: {
                contextProperties: [],
                appendToCacheKey: []
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.onAddNewContextProperty = this.onAddNewContextProperty.bind(this);
        this.onAddNewConstantValues = this.onAddNewConstantValues.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
    }

    componentDidMount() {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let cacheInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(cacheInfo.extras, "options")) {
            cacheInfo.extras.options = {};
            this.props.clickedNodeAction(cacheInfo);
        }
    }

    onPropertyUpdate(propertyName, index, value) {
        let propertyUpdate = this.state[propertyName];
        propertyUpdate[index] = value;
       const shouldFocusUpdate = {...this.state.shouldFocus};
       Object.keys(shouldFocusUpdate).forEach((key) => {
           shouldFocusUpdate[key] = shouldFocusUpdate[key].map(() => false);
       });
       shouldFocusUpdate[propertyName][index] = true;
        this.setState({
             [propertyName]: propertyUpdate,
             shouldFocus: shouldFocusUpdate,
            }, () => this.onOptionsUpdate(propertyName, this.state[propertyName])
        );
    }

    resetInputFocus() {
        const shouldFocusUpdate = {...this.state.shouldFocus};
        Object.keys(shouldFocusUpdate).forEach((key) => {
            shouldFocusUpdate[key] = shouldFocusUpdate[key].map(() => false);
        });
        this.setState({
            shouldFocus: shouldFocusUpdate,
            }
        );
    }
    onOptionsUpdate(type, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let cacheInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(cacheInfo.extras, "options")) {
            cacheInfo.extras.options = {};
        }
        cacheInfo.extras.options = {
            ...cacheInfo.extras.options,
            [type]: value
        };
        this.props.clickedNodeAction(cacheInfo);
    }

    updateOptions() {
        const cacheInfoOptions = this.state;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options = cacheInfoOptions;
        this.props.clickedNodeAction(panelInfo);
    }

    handleChange(property, value) {
        this.resetInputFocus();
        this.setState({
            [property]: value
        }, () => {
            this.updateOptions();
        });
    }

    onAddNewContextProperty() {
        this.setState(prevState => ({
                contextProperties: [
                    ...prevState.contextProperties,
                    {type: "contextProperty", value: ""}
                ]
            }),
            () => this.onOptionsUpdate("contextProperties", this.state.contextProperties)
        );
    }

    onAddNewConstantValues() {
        this.setState(prevState => ({
                appendToCacheKey: [
                    ...prevState.appendToCacheKey,
                    {type: "constantValue", value: ""}
                ]
            }),
            () => this.onOptionsUpdate("appendToCacheKey", this.state.appendToCacheKey)
        );
    }

    onDeleteProperty(propertyName, index) {
        const propertyUpdate = this.state[propertyName].filter((value, _index) => _index !== index);
        this.setState({
            [propertyName]: propertyUpdate
        }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    render() {
        return (
            <PanelLayout className="cache-panel">
                <ToggleTTLSeconds
                    label="Cache TTL (seconds)"
                    isNumberInputSelected={this.state.toggleTTLSecondsSelected}
                    handleToggleChange={() => this.handleChange("toggleTTLSecondsSelected", !this.state.toggleTTLSecondsSelected)}
                    numberInput={this.state.ttlSeconds}
                    handleInputChange={(event) => this.handleChange("ttlSeconds", event.target.value)}
                />
                <ToggleTTLSeconds
                    label="Cache additional random TTL (seconds)"
                    isNumberInputSelected={this.state.toggleRandomTTLSecondsSelected}
                    handleToggleChange={() => this.handleChange("toggleRandomTTLSecondsSelected", !this.state.toggleRandomTTLSecondsSelected)}
                    numberInput={this.state.extraRandomTtlSeconds}
                    handleInputChange={(event) => this.handleChange("extraRandomTtlSeconds", event.target.value)}
                />

                <MultiplePropertyContent label="Context Properties for CacheKey" onAddNew={this.onAddNewContextProperty}>
                    {this.state.contextProperties && this.state.contextProperties.map((contextProp, index) => (
                        <CacheContextPropertyInput key={crypto.randomUUID()} {...contextProp}
                                                   shouldFocus={this.state.shouldFocus.contextProperties[index]}
                                                   updateContextProperty={(value) => this.onPropertyUpdate("contextProperties", index, value)}
                                                   onDelete={() => this.onDeleteProperty("contextProperties", index)}/>

                ))}
                </MultiplePropertyContent>
                <MultiplePropertyContent label="Constant Values for CacheKey" onAddNew={this.onAddNewConstantValues}>
                    {this.state.appendToCacheKey && this.state.appendToCacheKey.map((ConstVal, index) => (
                        <CacheConstantValuesInput key={crypto.randomUUID()} {...ConstVal}
                                                  shouldFocus={this.state.shouldFocus.appendToCacheKey[index]}
                                                  updateconstantValue={(value) => this.onPropertyUpdate("appendToCacheKey", index, value)}
                                                  onDelete={() => this.onDeleteProperty("appendToCacheKey", index)}/>

                ))}
                </MultiplePropertyContent>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {
    hideModal,
    clickedNodeAction
})(CachePanel);